const crudConfig = {
    endpoint: 'systemproperties',
    functions: {
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'core',
            args: [],
            query: {
                filter: 'name=CSTE_DASHBOARD_URL,scope=rckms',
                property: 'queryClass=ByNameScope'
            }
        }
    }
};

export default crudConfig;
